// extracted by mini-css-extract-plugin
module.exports = {"scrollIcon":"ScrollIcon_scrollIcon__UycZg"};